// src/data/productData.js
import metashape from '../images/products/metashape_logo.png';
import simactive from '../images/products/simactive_logo.png';
import globalMapper from '../images/products/global_mapper_pro_logo.png';
import training from '../images/products/training_logo.png';

const productData = [
  {
    id: 1,
    title: 'Metashape',
    descriptionKey: 'metashape.desc', // i18n 키
    image: metashape,
    alt: 'Metashape logo',
  },
  {
    id: 2,
    title: 'Correlator3D',
    descriptionKey: 'correlator.desc',
    image: simactive,
    alt: 'Simactive logo',
  },
  {
    id: 3,
    title: 'Global Mapper',
    descriptionKey: 'globalmapper.desc',
    image: globalMapper,
    alt: 'Global Mapper logo',
  },
  {
    id: 4,
    title: 'Training & Education',
    descriptionKey: 'training.desc',
    image: training,
    alt: 'Training logo',
  },
];

export default productData;
